const resource = '/admin/v1/app-options'

export default $axios => ({
  getList(payload) {
    return $axios.get(`${resource}`, {params: payload})
  },
  show(id) {
    return $axios.get(`${resource}/${id}`)
  },
  update(id, payload) {
    return $axios.put(`${resource}/${id}`, payload)
  },
})
